import { Menu, MenuItem, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  anchorEl: any | null;
  menuOpen: boolean;

  handleAddSingleContact(): void;

  handleAddMultipleContacts(): void;

  handleCloseMenu(): void;
}

const AddContactMenu: React.FC<Props> = ({ anchorEl, menuOpen, handleAddSingleContact, handleAddMultipleContacts, handleCloseMenu }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      classes={{ list: classes.menuList, paper: classes.menuPaper }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          style: {
            width: 'auto',
          },
        },
      }}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableAutoFocusItem={true}
      disableRestoreFocus={true}
    >
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleAddSingleContact();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('singleContact')}</Typography>
      </MenuItem>
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleAddMultipleContacts();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('multipleContacts')}</Typography>
      </MenuItem>
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '6px',
    maxHeight: '33vh',
    width: '100%',
    marginLeft: '8px',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(15),
    borderBottom: `1px solid ${theme.palette.greys.lighter}`,
    padding: '6px 16px',
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: theme.palette.action.hover,
    },
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main,
    },
  },
}));

export default AddContactMenu;
